// CRUD Form input for the hearing aid model
/*
Required fields:
id: number,
StockCode: string,
Price: number,
Type: Type,
NappiCode: String,
ChargeType: ChargeType,
Description: string
Brand: string
 */
import * as React from 'react';
import { Autocomplete, Button, Grid, InputAdornment, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { hearingAid } from '../pages/generator';
import { useEffect } from 'react';

export enum ChargeType {
    RECHARGABLE = 'RECHARGABLE',
    NON_RECHARGABLE = 'NON_RECHARGABLE'
}

export enum HearingAidType {
    RIC = 'RIC',
    BTE = 'BTE',
    IN_THE_EAR = 'IN_THE_EAR'
}

export type HearingAid = {
    id: number;
    StockCode: string;
    Price: number;
    Type: HearingAidType;
    NappiCode: string;
    ChargeType: ChargeType;
    Description: string;
    Brand: string;
    ProductClass: string;
    Colour: string;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default function HearingAidDialog({ hearingAid, fullBrandList, onCancel, onSubmit }) {
    const [chargeType, setChargeType] = React.useState<ChargeType>(
        hearingAid.ChargeType === 'Rechargeable' ? ChargeType.RECHARGABLE : ChargeType.NON_RECHARGABLE
    );
    const [hearingAidType, setHearingAidType] = React.useState<HearingAidType>(
        hearingAid.Type === 'RIC' ? HearingAidType.RIC : hearingAid.Type === 'BTE' ? HearingAidType.BTE : HearingAidType.IN_THE_EAR
    );

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const [brandList, setBrandList] = React.useState<string[]>([...new Set(fullBrandList)]);
    const [stockCode, setStockCode] = React.useState<string>(hearingAid.StockCode);
    const [brand, setBrand] = React.useState<string>(hearingAid.Brand);
    const [productClass, setProductClass] = React.useState<string>('Device');
    const [description, setDescription] = React.useState<string>(hearingAid.Description);
    const [colour, setColour] = React.useState<string>('N/A');
    const [nappiCode, setNappiCode] = React.useState<string>(hearingAid.NappiCode);
    const [price, setPrice] = React.useState<number>(hearingAid.Price);

    const changeChargeType = (event: SelectChangeEvent) => {
        setChargeType(event.target.value as unknown as ChargeType);
    };

    const changeHearingAidType = (event: SelectChangeEvent) => {
        setHearingAidType(event.target.value as unknown as HearingAidType);
    };

    function onConfirm(e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) {
        const ha: HearingAid = {
            id: hearingAid.id,
            StockCode: stockCode,
            Price: price,
            Type: hearingAidType,
            NappiCode: nappiCode,
            ChargeType: chargeType,
            Description: description,
            Brand: brand,
            ProductClass: 'Device',
            Colour: 'N/A'
        };
        onSubmit(ha);
    }

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField value={stockCode} id="StockCode" label="Stock Code" onChange={(e) => setStockCode(e.target.value)} />
                </Grid>
                <Grid item xs={6}>
                    <TextField value={nappiCode} id="NappiCode" label="Nappi Code" onChange={(e) => setNappiCode(e.target.value)} />
                </Grid>
                <Grid item xs={5}>
                    <Autocomplete
                        id="Brand"
                        freeSolo
                        autoSelect={true}
                        value={brand}
                        renderInput={(params) => <TextField {...params} label="Brand" />}
                        options={brandList.map((brand) => brand)}
                        onChange={(event, value) => {
                            if (typeof value === 'string') {
                                setBrand(value);
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={6}>
                    <TextField
                        id="Price"
                        label="Price"
                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">R</InputAdornment>
                        }}
                        value={price}
                        onChange={(e) => setPrice(Number(e.target.value))}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputLabel id="ChargeType">Charge Type</InputLabel>
                    <Select id="ChargeType" label="Charge Type" value={chargeType.toString()} onChange={changeChargeType}>
                        <MenuItem value={ChargeType.RECHARGABLE}>Rechargable</MenuItem>
                        <MenuItem value={ChargeType.NON_RECHARGABLE}>Non-Rechargable</MenuItem>
                    </Select>
                </Grid>
                <Grid item xs={6}>
                    <InputLabel id="Type-helper">Type</InputLabel>
                    <Select id="HAType" label="Type" value={hearingAidType.toString()} onChange={changeHearingAidType}>
                        <MenuItem value={HearingAidType.RIC}>RIC</MenuItem>
                        <MenuItem value={HearingAidType.BTE}>BTE</MenuItem>
                        <MenuItem value={HearingAidType.IN_THE_EAR}>In the Ear</MenuItem>
                    </Select>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        value={description}
                        fullWidth
                        id="Description"
                        label="Name"
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" sx={{ m: 2 }}>
                <Button sx={{ mr: 1 }} variant="contained" onClick={(e) => onConfirm(e)}>
                    Confirm
                </Button>
                <Button sx={{ mr: 2 }} variant="outlined" onClick={(e) => onCancel(e)}>
                    Cancel
                </Button>
            </Grid>
        </div>
    );
}
